var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrowfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.794,
    height: 6.168,
    viewBox: "0 0 10.794 6.168",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11233",
    "data-name": "Path 11233",
    d: "M64.937,237.549H55.493a.643.643,0,0,0-.474.2.68.68,0,0,0,0,.964l4.722,4.8a.655.655,0,0,0,.949,0l4.722-4.8a.68.68,0,0,0,0-.964A.643.643,0,0,0,64.937,237.549Z",
    transform: "translate(-54.818 -237.549)",
    fill: "#156ae6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowfill);
export default __webpack_public_path__ + "static/media/downarrowfill.5e913aab.svg";
export { ForwardRef as ReactComponent };